module.exports = __webpack_public_path__ + "static/img/logo.a4d18da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 191
// module chunks = 1